<template>
  <div class="my-item z-info">
    <template >
      <div style="min-height: 400px;">
        <Row :gutter="30">
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            class="w-20"
          > 
            <div class="addPro pro"  @click="addCert">
              <i class="icon iconfont icon-jia3"></i>
              <span>添加证件</span>
            </div>
          </Col>
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            v-for="(item, index) in CarList"
            :key="'releaseInt-' + index"
            class="w-20"
            v-if="CarList.length"
          > 
            <div class="pro" >
              <div class="pro-top">
                <div class="pro-top-l">
                  <p>姓名：{{item.firstName}}</p>
                  <p>职务：{{item.jobTitle}}</p>
                  <p>身份证号：{{item.idCard}}</p>
                  <p>电话：{{item.tel}}</p>
                </div>
                <div class="state-Type">
                  <span v-if="item.commandId == 1" style="color:#1890ff;">状态：新增</span>
                  <span v-if="item.commandId == 2" style="color:#fe781d;">状态：修改</span>
                  <span v-if="item.commandId == 3" style="color:#009944;">状态：删除</span>
                </div>
              </div>
              <div class="pro-tool">
                <div class="pro-tool-item" @click="editModal(item)" style="color:#1890ff">编辑</div>
                <div class="pro-tool-line"></div>
                <div class="pro-tool-item z-del">
                  <Poptip confirm title="您确认删除这条内容吗？"  @on-ok="delItem(item)" style="color:#ff0000">删除</Poptip>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <!-- <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div> -->
      </div>
    </template>
    <addCert :show="carShow" :NoNumber="NoNumber" :yesNumber="yesNumber" @close="closeModal" @addFinsh="addFinsh"></addCert>
    <editCert :show="editShow" :editInfo="editInfo" :type="1" @close="closeEdit"></editCert>
    <addCertExcel :addExcelShow="addExcelShow" @close="closeExcel" :init="init"></addCertExcel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addCert from "./add-cert";
import editCert from "./edit-cert";
import addCertExcel from "./add-cret-excel"
export default {
  name: "exhibition-car-no",
  props:['addShow'],
  data() {
    return {
      editShow: false,
      editInfo: null,
      addExcelShow:false,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      carShow:false,
      CarList:[],
      NoNumber:0, //未审核的信息条数
      yesNumber:0
    };
  },
  watch:{
    addShow(val){
      // if(val){
      //   this.addCert();
      // }
    }
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    header() { return this.$store.state.header},
  },
  components: {
    addCert,
    editCert,
    addCertExcel
  },
  created() {
    this.init();
  },
  methods: {
    closeModal(){ // 关闭弹框
      this.carShow = false;
      this.$emit('closeModal');
    },
    closeExcel(){ // 关闭下载弹框
      this.addExcelShow = false;
    },
    closeEdit() {
      this.editShow = false;
      this.init();
    },
    addCert() {
      // if (this.joinInfo.boothArea<9&&this.yesNumber+this.NoNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&this.yesNumber+this.NoNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }
      this.carShow = true;
    },
    addCert1(){
      // if (this.joinInfo.boothArea<9&&this.yesNumber+this.NoNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&this.yesNumber+this.NoNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }
      this.addExcelShow=true
    },
    editModal(item){
      this.editShow = true;
      this.editInfo = item;
    },
    delItem(item){ // 删除
      this.$http.delete(`/api/DeExCardDown?recordId=${item.recordId}`,this.header)
                    .then(res=>{
                      if(res.status === 200 && res.data.successed){
                        this.$Message.success("删除成功！");
                        this.init();
                      }else{
                        this.$Message.error("删除失败，请重新尝试");
                      }
                    })
    },
    init(){
      this.$http.post(`/api/DeExCardUp/GetList`, {JoinId: this.joinInfo.joinId},this.header)
              .then(res=>{
                if(res.status === 200 && res.data.length){
                  this.yesNumber= res.data.length
                }
              })
      // this.$http.get(`/api/DeExCardDown/GetDeExCardDownAuditByJoin?JoinId=${this.joinInfo.joinId}`,this.header)
      //   .then(res=>{
      //     if(res.status === 200 && res.data.length){
      //       this.CarList = res.data;
      //       this.NoNumber= res.data.length
      //     } else {
      //       this.CarList = [];
      //     }
      //   })
    },
    // 添加完成
    addFinsh(){
      this.init();
    }
  },
};
</script>

<style scoped lang="scss">
.my-item {
  min-width: 600px;
  padding: 24px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .addPro{
    padding:40px;
    .icon{
      font-size: 60px;
      text-align: center;
      display: block;
      color:#999;
    }
    span{
      display: block;
      font-size: 18px;
      color:#999;
      text-align: center;
      position: relative;
      top:-5px;
    }
  }
  .pro {
    margin-bottom: 20px;
    position: relative;
    height: 210px;
    background-color: #fafafa;
  	box-shadow: 0px 2px 6px 0px 
		rgba(136, 156, 176, 0.1);
    &-top {
      width: 100%;
      background: #fff;
      padding:20px;
      display: flex;
      position: relative;
      height: 162px;
      padding-bottom: 20px;
      &-l{
        width: 100%;
        h3{
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          color: #333;
          padding-bottom: 10px;
        }
        p{
          font-size: 14px;
          line-height: 16px;
          padding:8px 0;
          color: #333;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .state-Type {
        position: absolute;
        right: 20px;
        bottom: 20px;
      }
    }

    &-tool {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      &-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
}
</style> 
